<template>
  <Echarts :option="baseOption" :height="this.isMobile?'300px':'630px'"></Echarts>
</template>

<script>
import Echarts from '@/components/Echarts'
import Query from '@/utils/query'

export default {
  name: "BarPie",
  data() {
    return {
      baseOption: {}
    }
  },
  mixins: [Query],
  props: ['type','isMobile', 'tabType'],
  components: {Echarts},
  methods: {
    getLastFive(data) {
      let allYear = []
      let series = []
      for (let key in data) {
        allYear.push(key)
        const dk = data[key]
        const seriesTitle = this.tabType === 'china' ? '中国高校专利情况' : '深圳市高校专利情况'
        series.push({
          title: {
            text: key + seriesTitle,
            textStyle: {
              fontSize: this.isMobile?12:18
            }
          },
          series: [
            {data: [dk.FMSZ_Amount_Of_Public_Year]}, // 发明申请公开量
            {data: [dk.FMSQ_Year]}, // 发明授权量
            {data: [dk.SYXX_Amount_Of_Public_Year]}, // 实用新型公开量
            {data: [dk.WGSJ_Amount_Of_Public_Year]}, // 外观设计公开量
            {data: [dk.PCT_Amount_Of_Public_Year]}, // pct申请公开量
            /*{
              data: [dk.FMSQ_Year,
                {
                  value: dk.PCT_Amount_Of_Public_Year,
                  itemStyle: {color: '#2f4554'}
                }, '', ''] // 后面两个用于占位
            },*/
            // {
            //   data: [
            //     {name: '外观设计公开量', value: dk.WGSJ_Amount_Of_Public_Year},
            //     {name: '发明申请公开量', value: dk.FMSZ_Amount_Of_Public_Year},
            //     {name: '实用新型公开量', value: dk.SYXX_Amount_Of_Public_Year}
            //   ]
            // }
          ]
        })
      }
      this.baseOption = {
        baseOption: {
          timeline: {
            axisType: 'category',
            autoPlay: true,
            playInterval: 3000,
            data: allYear,
            left: this.isMobile?10:'',
            right: this.isMobile?10:''
            /*data: ['2016', '2017', '2018', '2019',
              {
                value: '2020',
                /!*tooltip: {
                  formatter: '{b} GDP达到一个高度'
                },*!/
                symbol: 'diamond',
                symbolSize: 16
              }
            ],*/
          },
          tooltip: {
            /*formatter: function (val) {
              console.log(val)
            }*/
          },
          // color: ['#c23531','#2f4554','#61a0a8'],
          legend: {
            left: 'right',
            top: this.isMobile?16:'',
            data: ['发明申请公开量', '发明授权公开量', '实用新型公开量', '外观设计公开量', 'PCT申请公开量'],
            textStyle: {
              fontSize: this.isMobile?12:16
            },
            itemWidth: this.isMobile?12:25,
            itemHeight: this.isMobile?7:14
          },
          calculable: true,
          grid: {
            left: this.isMobile?50:80,
            top: this.isMobile?70:80,
            bottom: this.isMobile?80:100,
            right: this.isMobile?5:50
            /*tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow',
                label: {
                  show: true,
                  formatter: function (params) {
                    return params.value.replace('\n', '');
                  }
                }
              }
            }*/
          },
          xAxis: [
            {
              type: 'category',
              // data: ['发明授权量', 'PCT申请公开量'],
              show: false
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                fontSize: this.isMobile?10:16
              }
            }
          ],
          series: [
            {name: '发明申请公开量', type: 'bar', barWidth: this.isMobile?'80px':'140px'},// 用于占位，避免和饼图重叠
            {name: '发明授权公开量', type: 'bar', barWidth: this.isMobile?'40px':'140px'},
            {name: '实用新型公开量', type: 'bar', barWidth: this.isMobile?'80px':'140px'},// 用于占位，避免和饼图重叠
            {name: '外观设计公开量', type: 'bar', barWidth: this.isMobile?'80px':'140px'},// 用于占位，避免和饼图重叠
            {name: 'PCT申请公开量', type: 'bar', barWidth: this.isMobile?'40px':'140px'},
            // {
            //   name: '',
            //   type: 'pie',
            //   center: [this.isMobile?'75%':'75%', this.isMobile?'35%':'35%'],
            //   radius: '28%',
            //   z: 100,
            //   label: {
            //     fontSize: this.isMobile?8:16,
            //     formatter: (params) => {
            //       let str = params.name
            //       if(this.isMobile && str.length > 4){
            //         str = str.replace(/(.{1,4})/g,'$1\n')
            //       }
            //       return str
            //     }
            //   },
            //   labelLine: {
            //     length: this.isMobile?5:20,
            //     length2: this.isMobile?5:25
            //   }
            // }
          ]
        },
        options: series
        /*options: [
          {
            title: {text: '2016深圳市高校专利情况'},
            series: [
              {data: [400]},
              {data: [100]},
              {data: []},
              {
                data: [
                  {name: '外观设计公开量', value: 100},
                  {name: '发明申请公开量', value: 200},
                  {name: '实用新型公开量', value: 300}
                ]
              }
            ]
          },
          {
            title: {text: '2017深圳市高校专利情况'},
            series: [
              {data: [808]},
              {data: [100]},
              {data: []},
              {
                data: [
                  {name: '外观设计公开量', value: 100},
                  {name: '发明申请公开量', value: 200},
                  {name: '实用新型公开量', value: 500}
                ]
              }
            ]
          },
          {
            title: {text: '2018深圳市高校专利情况'},
            series: [
              {data: [80]},
              {data: [1010]},
              {data: []},
              {
                data: [
                  {name: '外观设计公开量', value: 100},
                  {name: '发明申请公开量', value: 200},
                  {name: '实用新型公开量', value: 300}
                ]
              }
            ]
          },
          {
            title: {text: '2019深圳市高校专利情况'},
            series: [
              {data: [80]},
              {data: [100]},
              {data: []},
              {
                data: [
                  {name: '外观设计公开量', value: 100},
                  {name: '发明申请公开量', value: 200},
                  {name: '实用新型公开量', value: 500}
                ]
              }
            ]
          },
          {
            title: {text: '2020深圳市高校专利情况'},
            series: [
              {data: [80]},
              {data: [100]},
              {data: []},
              {
                data: [
                  {name: '外观设计公开量', value: 100},
                  {name: '发明申请公开量', value: 200},
                  {name: '实用新型公开量', value: 500}
                ]
              }
            ]
          },
        ]*/
      }
    }
  },
  computed: {},
  mounted() {
    this.getAjax(this.type, data => {
      this.getLastFive(data)
    })
  }
}
</script>
